import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Quilleditor } from "../../Quilleditor/Quilleditor";
import RangeSilder from "../../RangeSilder/RangeSilder";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import Slider from "../../RcSlider/rcSlider";
export default function SkillItem(props) {
  const [t, i18n] = useTranslation("common");
  const [dotValue, setDotValue] = useState("");

  const setValueDot = (value) => {
    props.setDotValue(value);
  };
  return (
    <>
      <div className="row px-3 mb-3">
        <div className="col-md-12 mb-3 mr-2">
          {!props.showPopup && (
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
              alt="trash"
              className="ml-1 delete_icon float-right"
              onClick={props.handleItemDelete}
            />
          )}
        </div>
        <div className="col-md-6">
          <EditorInput
            label={t(`skills.name`)}
            value={props.res.name}
            name="name"
            autoComplete="off"
            className={`form-control  ${props.sectionId}focus${props.index}`}
            onChange={props.resumeHandler}
            onBlur={props.resumeUpdate}
          />
        </div>
        {props &&
          props.res &&
          props.res.showFields &&
          props.res.showFields.slider && (
            <div className="col-md-6">
              <label>{t(`skills.level`)}</label>
              <div className="slide-center">
                <Slider
                  skill
                  dots
                  index={props.index}
                  value={props.res.level}
                  sectionId={props.sectionId}
                  resumeHandler={props.resumeHandler}
                  languageHandler={props.languageHandler}
                  dotValue={setValueDot}
                  onBlur={props.resumeUpdate}
                />
              </div>
            </div>
          )}
      </div>
    </>
  );
}
